import React from 'react';

const StockFxSnapshotFields = ({ values, original = {}, onChange, disabled = false }) => (
  <fieldset className="space-y-2 rounded-md border border-gray-200 p-3 dark:border-gray-600">
    <legend className="px-1 text-sm font-semibold text-gray-700 dark:text-gray-200">Transaction FX snapshot</legend>
    <p className="text-xs text-gray-500 dark:text-gray-400">
      Stored with this transaction, not in shared FX history. Broker rate is trading-currency units per one base-currency unit.
    </p>
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {[
        ['brokerBaseCurrency', 'Broker base currency', 'EUR'],
        ['brokerFXRate', 'Broker exchange rate', 'Native units per base unit'],
        ['fxRateToUSD', 'USD per trading-currency unit', 'Exact historical rate, if needed'],
      ].map(([field, label, placeholder]) => (
        <label key={field} className="block text-xs text-gray-600 dark:text-gray-300">
          {label}
          <input
            name={field}
            value={values[field] ?? ''}
            onChange={(event) => onChange(field, event.target.value)}
            disabled={disabled}
            inputMode={field === 'brokerBaseCurrency' ? 'text' : 'decimal'}
            placeholder={placeholder}
            className="mt-1 w-full rounded border border-gray-300 bg-white px-2 py-2 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
          />
        </label>
      ))}
    </div>
    {original.brokerBaseAmount != null && (
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Original broker value: {original.brokerBaseAmount} {original.brokerBaseCurrency}
      </p>
    )}
    {original.fxSource && <p className="text-xs text-gray-500 dark:text-gray-400">Saved source: {original.fxSource}</p>}
    <p className="text-xs text-gray-500 dark:text-gray-400">
      A USD accounting rate can be derived from the broker rate and the base currency's rate on the trade date. If that date is unavailable, enter a verified historical USD rate; today's rate is not substituted.
    </p>
  </fieldset>
);

export default StockFxSnapshotFields;
